import { useTimeSince } from '@/utils/hooks'

export interface TimeSinceProps {
  timestamp: Date
  cutOff?: number
}

export const TimeSince: React.JSX.CFC<TimeSinceProps> = ({
  timestamp,
  cutOff,
}) => {
  return <>{useTimeSince(timestamp, cutOff)}</>
}
